const HTML_ENTITIES: Record<string, string> = {
  "&nbsp;": " ",
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&#39;": "'",
  "&oacute;": "ó",
};

/**
 * Catalog descriptions arrive as HTML. Turn one into a single line of plain
 * text, for places where the markup cannot be rendered — a teaser inside a
 * button, an aria-label or a meta description.
 */
export const stripHtml = (html?: string | null): string => {
  if (!html) return "";

  const withoutTags = html.replace(/<[^>]*>/g, " ");
  const decoded = withoutTags.replace(
    /&(?:nbsp|amp|lt|gt|quot|#39|oacute);/g,
    (entity) => HTML_ENTITIES[entity] ?? entity,
  );

  return decoded.replace(/\s+/g, " ").trim();
};
